export default __webpack_public_path__ + "static/media/detailexplain.cdbc3787.png";